<template>
    <div class="image-card">
        <div class="blog-author mb--20" :style="`background-image: url(${img_base_foto}${bgImg}.png);`">
            <div class="author">
                <div class="author-thumb">
                    <img v-show="avatar != null" :src="`${img_base}${avatar}.png`" alt="avatar">
                </div>
                <div class="info white">
                    <h6 class="white">{{ title }}</h6>
                    <span>{{ description }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "LoanTypeCard",
    props: [
        "title",
        "description",
        "avatar",
        "bgImg"
    ],
    data() {
        return {
            img_base: "https://cdn.redgirasol.com/nuevo_portal/icons/icon-",
            img_base_foto: "https://cdn.redgirasol.com/nuevo_portal/fotografias/foto-"
        }
    }
}

</script>

<style scoped>

.image-card > div.blog-author {
    background-repeat: round;
    padding-left: 20px;
    padding-right: 13px;
}

.blog-author {
    min-height: 17.3rem !important;
}

ul.list-style {
    line-height: 14px;
}

.author-thumb {
    width: 5rem;
}

.info span {
    font-size: 1rem !important;
}

@media only screen and (max-width: 575px) {
    .author {
        text-align: center;
        text-align: -webkit-center;
    }
}

</style>